import { List } from 'immutable';
import { companyConstants } from '../constants';

export function companies(state = {}, action) {
  switch (action.type) {
    case companyConstants.COMPANY_LIST_LOADING:
      return {
        ...state,
        listLoading: true
      };
    case companyConstants.COMPANY_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case companyConstants.COMPANY_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: [],
        listError: action.error
      };
    case companyConstants.COMPANY_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case companyConstants.COMPANY_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case companyConstants.COMPANY_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case companyConstants.COMPANY_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case companyConstants.COMPANY_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const companyIndex = state.items.findIndex(val => val.id == action.response.id);

      if (companyIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(companyIndex, action.response),
        editLoading: false,
        editError: null
      };
    }

    case companyConstants.COMPANY_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case companyConstants.COMPANY_SETTINGS_EDIT_LOADING:
      return {
        ...state,
        settingsEditLoading: true
      };

    case companyConstants.COMPANY_SETTINGS_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const companyIndexEdit = state.items.findIndex(val => val.id == action.companyId);

      if (companyIndexEdit === -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(companyIndexEdit, {
          ...Array.from(state.items)[companyIndexEdit],
          companySettings: action.response
        }),
        editLoading: false,
        editError: null
      };
    }

    case companyConstants.COMPANY_SETTINGS_EDIT_FAILURE:
      return {
        ...state,
        settingsEditLoading: false,
        settingsEditError: action.error
      };

    case companyConstants.COMPANY_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case companyConstants.COMPANY_DELETE_SUCCESS: {
      const { companyId } = action;

      if (!state.items) {
        return state;
      }

      const companyIndex = state.items.findIndex(val => val.id == companyId);

      if (companyIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(companyIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case companyConstants.COMPANY_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case companyConstants.COMPANY_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    default:
      return state;
  }
}
